import { memo } from 'react';
import type {
  CameraSlice,
  FeatureDeps,
  Point2D,
} from '../../../../canvas/core';
import { createStoreHooks } from '../../../../canvas/core';
import {
  getPageCoordinateTransformContext,
  pageCoordinates,
  type PageLayoutData,
  type PageLayoutSlice,
} from '../../../core';
import {
  type createRotationFeature,
  getPageRotation,
} from '../../page-rotation';

type AnchoredTestOverlayDeps = CameraSlice &
  PageLayoutSlice &
  FeatureDeps<[], [typeof createRotationFeature]>;

const { useStore } = createStoreHooks<AnchoredTestOverlayDeps>();

type AnchoredTestOverlayProps = {
  pageId: number;
  layout: PageLayoutData;
  anchor: Point2D;
  label: string;
};

export const AnchoredTestOverlay = memo(
  ({ pageId, layout, anchor, label }: AnchoredTestOverlayProps) => {
    const rotation = useStore(state => getPageRotation(state, pageId));

    const ctx = getPageCoordinateTransformContext(
      { rotation: { values: { [pageId]: rotation }, animations: {} } },
      layout
    );
    const contentPoint = pageCoordinates.point.pageToContent(ctx)(anchor);

    return (
      <g transform={`translate(${contentPoint.x}, ${contentPoint.y})`}>
        <circle r={5} fill="red" />
        <rect
          x={10}
          y={-15}
          width={80}
          height={24}
          fill="white"
          stroke="red"
          strokeWidth={1}
        />
        <text x={15} y={2} fontSize={12} fill="black">
          {label}
        </text>
        <line x1={0} y1={0} x2={10} y2={0} stroke="red" strokeWidth={1} />
      </g>
    );
  }
);
